module.exports = __webpack_public_path__ + "media/images/top/budget_table/hojin_pc_over1000-28f9ac8b75fb78c2eb539bc667bd807f.png";